<div class="horizinns-container terms-container center">
    <div class="mat-row margin-auto text-center">
        <img src="/assets/images/logo_full_900.png" class="main-logo" alt="Horizinns logo" />
        <mat-card class="terms-card left">
            <mat-card-header class="margin-auto">
                <h1 class="center">Terms &amp; Conditions</h1>
            </mat-card-header>
            <mat-card-content>
                <h3>Eligibility</h3>
                <p>To use our services, you must be:</p>
                <ul>
                    <li>At least 18 years old or the legal age of majority in your jurisdiction.</li>
                    <li>Able to enter into legally binding agreements.</li>
                    <li>In compliance with all local, state, and federal regulations related to short-term rental hosting and booking.</li>
                </ul>
                
                <h3>Services Overview</h3>
                <p>Horizinns provides a subscription-based listing platform where property owners and managers ("Hosts") can post vacation rental properties, and travelers ("Guests") can view those listings.</p>
                <p>Horizinns is not a property manager or broker and does not participate in any transaction between Hosts and Guests.</p>
                
                <h3>Subscriptions &amp; Fees</h3>
                <ul>
                    <li>All currency is in USD. </li>
                    <li>Hosts must select a subscription plan to list properties.</li>
                    <li>Fees are clearly displayed at checkout and are billed annually prior to subscription.</li>
                    <li>All fees are non-refundable unless otherwise specified in writing.</li>
                    <li>We reserve the right to change pricing or features at any time with notice.</li>
                </ul>

                <h3>User Responsibilities</h3>
                <h4>Host Responsibilities:</h4>
                <p>Hosts agree to:</p>
                <ul>
                    <li>Provide accurate and up-to-date property information.</li>
                    <li>Maintain all necessary licenses, insurance, and legal permissions to operate a vacation rental.</li>
                    <li>Respond to inquiries and manage bookings professionally.</li>
                </ul>

                Horizinns reserves the right to remove listings that are misleading, violate laws, or fail to meet community standards.

                <h4>Guest Responsibilities:</h4>
                <p>Guests acknowledge that:</p>
                <ul>
                    <li>Booking arrangements are solely between the Guest and the Host.</li>
                    <li>Horizinns does not verify the accuracy of listings.</li>
                    <li>All disputes, refunds, or damages are to be handled directly with the Host.</li>
                </ul>

                <h3>Prohibited Uses</h3>
                <p>You may not use the Platform to:</p>
                <ul>
                    <li>Violate any laws or regulations.</li>
                    <li>Post false, misleading, or harmful content.</li>
                    <li>Spam or solicit users.</li>
                    <li>Interfere with the platform's security or functionality.</li>
                    <li>Hosts are <strong>not permitted</strong> to have indoor surveillance cameras (violators will be removed from Horiznns without refund).</li>
                </ul>

                <h3>Intellectual Property</h3>
                <p>All content on the Platform (including logo, branding, layout, design, and text) is owned by or licensed to Horizinns, LLC. You may not copy, reproduce, or redistribute our content without permission.</p>

                <h3>Disclaimers</h3>
                <ul>
                    <li>Horizinns does not guarantee bookings, revenue, or guest behavior.</li>
                    <li>Listings are user-generated content and we do not verify the accuracy, legality, or safety of any property.</li>
                    <li>Horizinns disclaims all liability for losses, damages, or disputes arising from use of the Platform.</li>
                </ul>

                <h3>Limitation of Liability</h3>
                <p>To the fullest extent permitted by law, Horizinns, LLC will not be liable for:</p>
                <ul>
                    <li>Any indirect, incidental, or consequential damages.</li>
                    <li>Loss of profits, data, or reputation.</li>
                    <li>Any claims arising from interactions between Hosts and Guests.</li>
                </ul>
                <p>Our total liability for any claim shall not exceed the total subscription fees paid by you in the past 12 months.</p>

                <h3>Privacy</h3>
                <p>Your privacy is important to us. Please review our Privacy Policy for information on how we collect, use, and protect your data.</p>

                <h3>Termination</h3>
                <p>We may suspend or terminate your access at our discretion if you violate these Terms. You may cancel your subscription at any time, but no refunds will be issued for remaining time in your billing cycle.</p>

                <h3>Modifications</h3>
                <p>We may update these Terms from time to time. Continued use of the Platform after changes are made constitutes acceptance of the revised Terms.</p>

                <h3>Governing Law</h3>
                <p>These Terms are governed by the laws of the State of Florida, without regard to conflict of law principles.</p>

                <h3>Contact Us</h3>
                <p>If you have questions or concerns, please contact:</p>

                <p>
                Horizinns, LLC<br/>
                <button mat-flat-button class="metallic-text-btn-blue" routerLink="/contact">Contact Us</button>
                </p>
                
            </mat-card-content>
        </mat-card>
    </div>
</div>
